module.exports = __webpack_public_path__ + "static/media/DSC08765-2.0feac327.jpeg";